import React, { FunctionComponent } from "react";
import classnames from "classnames";
import "./Button.css";

export type IButtonProps = React.ButtonHTMLAttributes<{}>;

export const Button: FunctionComponent<IButtonProps> = (props): JSX.Element => {
  const { children, className, ...rest } = props;
  const classNames = classnames("mv-button", className);

  const content = React.Children.map(children, (child) => {
    if (typeof child === "string") {
      return <span className="mv-button__text">{child}</span>;
    }
    return child;
  });
  return (
    <button className={classNames} {...rest}>
      {content}
    </button>
  );
};
